export interface IDataLojas {
    id: number,
    nome: string,
    razao_social?: string
}

export const defValueLoja: IDataLojas = {
    id: 0,
    nome: ''
}